import { UserWorkoutSession, staticMachineAreaZones } from 'fitbeat.gym-core';
import { WorkoutType } from 'fitbeat.models';
import moment from 'moment-timezone';
import i18n from './i18n';

const workoutTypeDurationMap = {
  [WorkoutType.FullStudioWorkout]: '46Min',
  [WorkoutType.QuickStaticFunctionalWorkout]: '14Min',
  [WorkoutType.MediumStudioWorkout]: '28Min',
  [WorkoutType.QuickHomeOrStaticCardioWorkout]: '15min',
  [WorkoutType.MediumHomeOrStaticCardioWorkout]: '27min',
  [WorkoutType.FullHomeOrStaticCardioWorkout]: '40min',
  [WorkoutType.ExtraLongHomeOrStaticCardioWorkout]: '60Min',
};

const WORKOUT_SETUP_AND_END_DURATION = 2;

export const getSlotTime = (slot: UserWorkoutSession, isHomeBooking = false) => {
  if (!isHomeBooking) {
    const momentStartTime = moment(slot.startTime);
    const momentEndTime = moment(slot.endTime);
    // these ids has to remain here for bookings created pre-pause removal. Remove end of Feb 2025
    const slotHasPauses = (slot.workoutType as number) === 25
      || (slot.workoutType as number) === 15;
    const setupTime = slotHasPauses ? WORKOUT_SETUP_AND_END_DURATION : 0;
    const duration = moment(momentEndTime - momentStartTime).format('mm') - setupTime;

    return i18n.t('bookings:durationInMin', { duration });
  }
  return i18n.t(workoutTypeDurationMap[slot.workoutType]);
};
